import searchQuery from './search.query'
import searchResults from './search.results'

export default {
  register(eventContext) {
    ;[searchQuery, searchResults].forEach(callback => {
      callback(eventContext)
    })
  },
}
